// src/redux/settingsPages/language/languageAPi.js
import apiClient from '../../authentication/utils/core/axios';

// Simple detector for RTL languages
const isRtl = (code = '') => /^(ar|he|fa|ur)(-|$)/i.test(code);

const LanguageAPI = {
  async getAvailableLanguages() {
    // 2026-07-25: was a `.catch(() => apiClient.get('/i18n/locales'))`
    // fallback -- no /i18n/* route has ever existed on the backend (confirmed
    // via full route-map diff, see 08_MASTER_TODO.md #71), so on the one
    // real failure mode this existed to handle, it would have thrown an
    // uncaught rejection instead of the clean error this call already
    // propagates on its own. Removed rather than pointed at a real route,
    // since /settings/language/available is the only source of truth here.
    const res = await apiClient.get('/settings/language/available');
    // Normalize into { code, name, nativeName }
    const raw = res?.data ?? [];
    return raw.map((x) => ({
      code: x.code ?? x.locale ?? x.lang ?? 'en',
      name: x.name ?? x.englishName ?? 'English',
      nativeName: x.nativeName ?? x.localName ?? x.name ?? 'English',
    }));
  },

  async getUserLanguage() {
    const res = await apiClient.get('/settings/language');
    // Expect { language: 'en-US' } or { code: 'en-US' }
    const code = res?.data?.language ?? res?.data?.code ?? 'en';
    return { code, direction: isRtl(code) ? 'rtl' : 'ltr' };
  },

  async setUserLanguage(code) {
    const res = await apiClient.patch('/settings/language', { language: code });
    const saved = res?.data?.language ?? res?.data?.code ?? code;
    return { code: saved, direction: isRtl(saved) ? 'rtl' : 'ltr' };
  },
};

export default LanguageAPI;
